var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 607.4 311.1",
    style: {
      enableBackground: "new 0 0 607.4 311.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00447C;}\r\n\t.st1{fill:#8DC63F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.5,0.9c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C404.4,4.6,408,0.9,412.5,0.9L412.5,0.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411,165.2c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1C403,168.8,406.6,165.2,411,165.2 L411,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.8,144.7c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1C415.7,148.3,419.4,144.7,423.8,144.7 L423.8,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.4,83.1c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1C405.4,86.7,409,83.1,413.4,83.1 L413.4,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.8,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1 C417.7,107.2,421.3,103.6,425.8,103.6L425.8,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.8,42c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C387.8,45.7,391.4,42,395.8,42L395.8,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401,21.5c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1S396.5,21.5,401,21.5L401,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.9,62.6c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.7-8.1-8.1S394.4,62.6,398.9,62.6 L398.9,62.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.4,124.2c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1 C421.4,127.9,425,124.2,429.4,124.2L429.4,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.7,0.9c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C380.6,4.6,384.2,0.9,388.7,0.9 L388.7,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.3,165.2c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1S382.8,165.2,387.3,165.2L387.3,165.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.8,165.2c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C426.7,168.8,430.4,165.2,434.8,165.2 L434.8,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.3,0.9c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C428.2,4.6,431.8,0.9,436.3,0.9 L436.3,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.3,124.2c4.4,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C326.2,127.9,329.8,124.2,334.3,124.2L334.3,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.1,124.2c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C350,127.9,353.6,124.2,358.1,124.2L358.1,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.9,124.2c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C373.8,127.9,377.4,124.2,381.9,124.2L381.9,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.7,124.2c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C397.6,127.9,401.2,124.2,405.7,124.2L405.7,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.2,124.2c4.4,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C445.1,127.9,448.8,124.2,453.2,124.2L453.2,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477,124.2c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C468.9,127.9,472.5,124.2,477,124.2 L477,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.5,144.7c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.7-8.1-8.1 C344.4,148.3,348,144.7,352.5,144.7L352.5,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.3,144.7c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1C368.2,148.3,371.8,144.7,376.3,144.7 L376.3,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400,144.7c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.7-8.1-8.1C392,148.3,395.6,144.7,400,144.7 L400,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.6,144.7c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1C439.5,148.3,443.1,144.7,447.6,144.7 L447.6,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M471.4,144.7c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1C463.3,148.3,466.9,144.7,471.4,144.7 L471.4,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,83.1c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C334,86.7,337.6,83.1,342.1,83.1 L342.1,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.9,83.1c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C357.8,86.7,361.4,83.1,365.9,83.1 L365.9,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.6,83.1c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C381.6,86.7,385.2,83.1,389.6,83.1 L389.6,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.2,83.1c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C429.1,86.7,432.8,83.1,437.2,83.1 L437.2,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461,83.1c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1C452.9,86.7,456.5,83.1,461,83.1 L461,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M484.8,83.1c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C476.7,86.7,480.3,83.1,484.8,83.1 L484.8,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.6,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C322.6,107.2,326.2,103.6,330.6,103.6L330.6,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.4,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C346.4,107.2,350,103.6,354.4,103.6L354.4,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.2,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1 C370.1,107.2,373.7,103.6,378.2,103.6L378.2,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1S397.5,103.6,402,103.6L402,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.5,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C441.5,107.2,445.1,103.6,449.5,103.6L449.5,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.3,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C465.2,107.2,468.9,103.6,473.3,103.6L473.3,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.1,103.6c4.5,0,8.1,3.7,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1 C489,107.2,492.6,103.6,497.1,103.6L497.1,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.3,42c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C340.2,45.7,343.8,42,348.3,42L348.3,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.1,42c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C364,45.7,367.6,42,372.1,42L372.1,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.6,42c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C411.5,45.7,415.1,42,419.6,42L419.6,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.4,42c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1c-4.4,0-8.1-3.6-8.1-8.1C435.3,45.7,438.9,42,443.4,42 L443.4,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.2,42c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C459.1,45.7,462.7,42,467.2,42L467.2,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.4,21.5c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1S349,21.5,353.4,21.5L353.4,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.2,21.5c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1S372.7,21.5,377.2,21.5L377.2,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.8,21.5c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1S420.3,21.5,424.8,21.5L424.8,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.5,21.5c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1C440.5,25.1,444.1,21.5,448.5,21.5 L448.5,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.3,21.5c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1S467.8,21.5,472.3,21.5L472.3,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,62.6c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1C319.5,66.3,323.1,62.6,327.5,62.6 L327.5,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.3,62.6c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1S346.9,62.6,351.3,62.6L351.3,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.1,62.6c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1S370.6,62.6,375.1,62.6L375.1,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.7,62.6c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1S418.2,62.6,422.7,62.6L422.7,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.4,62.6c4.4,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1C438.4,66.3,442,62.6,446.4,62.6 L446.4,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.2,62.6c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1S465.8,62.6,470.2,62.6L470.2,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494,62.6c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1s-8.1-3.7-8.1-8.1S489.5,62.6,494,62.6L494,62.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,204.5c-9.4,0-18.9,5-18.9,15.4c0,12.9,11.5,14.4,22,16.4c18.1,4.6,44.6,9.7,44.6,33.7 c0,29.6-25.5,39.9-51.1,39.9c-27.1,0-46.3-10.6-45.4-40.7H27c-1,13.2,6.6,22.1,19.9,22.1c10.3,0,23.9-3.1,23.9-15.8 c0-14-17.1-15-27.3-17.6c-16.7-4.1-39.3-11.7-39.3-32.7c0-27.2,24.9-39.3,49.3-39.3c23.1,0,41,12.6,41,36.5l-24.7,0.1 C68.7,210.4,62.3,204.5,50,204.5L50,204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.9,309.9c-26.8,0-42.9-17.8-42.9-43.8s16.1-43.8,42.9-43.8c26.9,0,43,17.8,43,43.8 C196.8,292.1,180.7,309.9,153.9,309.9L153.9,309.9z M153.9,293.4c15,0,17.5-14.2,17.5-27.3c0-13.1-2.4-27.3-17.5-27.3 c-15,0-17.5,14.2-17.5,27.3S138.8,293.4,153.9,293.4L153.9,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.4,224.6h15v16.5h-15v66.4h-24.7v-66.4h-12.3v-16.5h12.3c-0.7-23.5,1.5-38.7,28.3-38.7 c4.5,0,9,0.5,13.5,1.2v15.4C235.1,200.5,234.7,208.4,235.4,224.6L235.4,224.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.2,208.2l24.6-8.9v25.3h18.6v16.5h-18.6v38.4c0,10.9,1.6,13.9,10.2,13.9c2.6,0,5.2-0.3,7.9-0.5v14.5 c-2.8,1.3-15.9,2.5-19.4,2.5c-19.2,0-23.3-10.1-23.3-28.1v-40.7h-16.6v-16.5h16.6V208.2L273.2,208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.3,208.2l24.7-8.9v25.3h18.6v16.5H365v38.4c0,10.9,1.6,13.9,10.2,13.9c2.6,0,5.3-0.3,7.9-0.5v14.5 c-2.8,1.3-16,2.5-19.4,2.5c-19.2,0-23.3-10.1-23.3-28.1v-40.7h-16.6v-16.5h16.6v-16.4H340.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.8,272.7c0,10.7,1.5,20.7,14.2,20.7c8.6,0,12.9-3.1,15.2-10.7h22.2c-2.1,20.4-18.1,27.2-37.4,27.2 c-28.4,0-39.7-16-39.7-43.6c0-24.9,14.5-44,39.7-44c15.5,0,28.4,5.3,35.3,19.8c2.3,4.6,3.5,9.5,4.1,14.8c0.7,5.1,0.7,10.4,0.7,15.9 L413.8,272.7L413.8,272.7z M442.6,256.2c0-9-2.5-17.4-14.6-17.4c-11.4,0-13.9,8.4-14.2,17.4H442.6L442.6,256.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "503.2,258.5 527.5,223.7 555,223.7 526.6,260 556.8,307.6 528,307.6 503.2,262.2 502.9,262.5  502.9,307.6 478.3,307.6 478.3,188.3 502.9,188.3 502.9,258.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.2,205.9c0,10.3,8.3,18.7,18.6,18.7c10.2,0,18.6-8.4,18.6-18.7s-8.3-18.7-18.6-18.7 C577.6,187.2,569.2,195.6,569.2,205.9z M572.5,205.9c0-8.5,6.9-15.4,15.3-15.4c8.4,0,15.3,6.9,15.3,15.4s-6.9,15.4-15.3,15.4 S572.5,214.4,572.5,205.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.4,204.2h2.5c1.6,0,2.7-0.1,3.1-0.2c0.4-0.1,0.7-0.4,1-0.7c0.2-0.4,0.4-0.8,0.4-1.3c0-0.6-0.2-1-0.5-1.4 s-0.8-0.6-1.3-0.7c-0.3,0-1.1,0-2.5,0h-2.7V204.2L584.4,204.2z M581,214.1V197h7.2c1.8,0,3.1,0.2,4,0.5c0.8,0.3,1.5,0.9,2,1.6 c0.5,0.8,0.8,1.7,0.8,2.7c0,1.3-0.4,2.4-1.1,3.2c-0.8,0.8-1.9,1.4-3.4,1.6c0.7,0.4,1.3,0.9,1.8,1.4s1.1,1.4,1.9,2.8l2.1,3.3h-4.1 l-2.5-3.7c-0.9-1.3-1.5-2.1-1.8-2.5c-0.3-0.3-0.7-0.6-1.1-0.7c-0.4-0.1-0.9-0.2-1.7-0.2h-0.7v7.1L581,214.1L581,214.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.822ba6a50154b928fe16deacea9d5acd.svg";
export { ForwardRef as ReactComponent };